import API from "../../../../../services/api";


export const RECONSTRUIDOS_API = {
    get: async (page = 1, search = null) => {
        return await API.get(`/reconstruidos?page=${page}${search || ''}`).then(res => res.data);
    },
    update: async (reconstruido) => {
        return API.put(`reconstruidos/${reconstruido.id}`, reconstruido).then(res => res.data);
    }
}